define(["jquery-ui"], function () {
    function autocompleteNavigation() {
        $(document)
            .ready(function () {
                var lastSearchTerm = "";
                var autocompleteNavigation = $(".autocomplete-navigation");
                var backButton = $(".search-result-empty .back-button");

                $(autocompleteNavigation).bind('autocompleteopen', function () {
                    $(this).data('is_open', true);
                });

                $(autocompleteNavigation).bind('autocompleteclose', function () {
                    $(this).data('is_open', false);
                });

                if (autocompleteNavigation.length > 0) {
                    $.ajax({
                        url: "/infocenter/AutocompleteNavigation/GetConfiguration",
                        data: {
                            pageId: autocompleteNavigation.attr("pageid")
                        },
                        success: function (configuration) {
                            autocompleteNavigation
                                .autocomplete({
                                    minLength: 1,
                                    source: function (request, response) {
                                        getData(request.term, autocompleteNavigation.attr("pageid"), response);
                                    },
                                    messages: {
                                        noResults: configuration.noResults,
                                        results: function (count) {
                                            return configuration.found
                                                .replace("{hits}", count)
                                                .replace("{searchTerm}", lastSearchTerm);
                                        }
                                    },
                                    select: function (event, ui) {
                                        window.location.href = ui.item.url;
                                    }
                                })
                                .data("ui-autocomplete")
                                ._renderItem = function (ul, item) {
                                return $("<li><div><a href='" + item.url + "'>" + item.value + "</a>")
                                    .attr("data-value", item.value)
                                    .appendTo(ul);
                            };
                        }
                    });
                }

                if (backButton.length > 0) {
                    backButton.click(function () {
                        window.history.back();
                    });
                }

                function getData(searchTerm, pageId, fn) {
                    $.ajax({
                        url: "/infocenter/AutocompleteNavigation/GetJson",
                        data: {
                            searchTerm: searchTerm,
                            pageId: autocompleteNavigation.attr("pageid")
                        },
                        success: function (data) {
                            lastSearchTerm = searchTerm;
                            fn(data.length === 0 ? [] : data);
                        }
                    });
                }

                function render(data) {
                    var resultListElement = $(".search-result-list");

                    if (data.length === 0) {
                        //Clear element
                        resultListElement.html("");
                        $(".search-result-empty").show();
                    } else {
                        $(".search-result-empty").hide();

                        var searchResultHtml = $.map(data, function (item) {
                            return ("<li><div><a href='" + item.url + "'>" + item.value + "</div></li>");
                        });

                        resultListElement.html(searchResultHtml.join(""));
                    }
                }

                $(autocompleteNavigation).keydown(function (e) {
                    if (e.keyCode === 13) {
                        e.preventDefault();
                        getData(this.value, autocompleteNavigation.attr("pageid"), render);

                        if ($(this).data('is_open')) {
                            $(this).autocomplete("close");
                        } else {
                            $(this).one("autocompleteopen", function () {
                                $(this).autocomplete("close");
                            });
                        }
                    }
                });
            });
    }

    return autocompleteNavigation;
});